// eslint-disable-next-line no-unused-vars
import { get } from 'lodash';

import Service from '../../services';

export const fetchFavorites = async params => {
  const response = await Service.isnGet(`/api/properties/get-favorite-by-ids${params}`, res => res);
  return response;
};
